import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonValues } from '../static/CommonValues';

export class ZebraPrinterTemplateDto extends BaseBus {
    constructor(data?: ZebraPrinterTemplateDto) {
        super(data);
    }
    CID(): any {
        return this.zebraPrinterTemplateId;
    }
    setId(id: any) {
        this.zebraPrinterTemplateId = id;
    }
    zebraPrinterTemplateId: any;
    templateName: string;
    templateDesc: string;
    templateContent: any;
}
